export default __webpack_public_path__ + "static/media/UniversLTStd-Cn.580a3d53.otf";